import { useQuery } from '@apollo/client';
import { AdminTripsFilterDocument } from '@website/types/graphqlOperations';
import { FC, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import type { RefinementListProvided } from 'react-instantsearch-core';
import { connectRefinementList } from 'react-instantsearch-dom';
import ReactSelect from 'react-select';

export const TripsDropdownFilter: FC<RefinementListProvided> = ({
  refine,
  currentRefinement,
}) => {
  const { data, loading } = useQuery(AdminTripsFilterDocument);

  const options = useMemo(() => {
    return (
      data?.trips.items.map((trip) => ({
        value: trip.id,
        label: trip.title,
      })) ?? []
    );
  }, [data?.trips.items]);

  const valueOptions = useMemo(() => {
    return options.filter((option) => currentRefinement.includes(option.value));
  }, [currentRefinement, options]);

  return (
    <Form.Group controlId="trip">
      <Form.Label>Filter By Trip</Form.Label>
      <ReactSelect
        isLoading={loading}
        id="filterByTrip"
        value={valueOptions}
        isMulti
        placeholder="Select..."
        onChange={(value) => {
          refine(value.map((option) => option.value));
        }}
        options={options}
      />
    </Form.Group>
  );
};

const FilterByTrips = connectRefinementList(TripsDropdownFilter);

export default FilterByTrips;
